import gql from 'graphql-tag'

export default gql`
  query ProductsQuery($category: [String!], $loanId: Int!) {
    products(category: $category) {
      rid
      name
      term
      category
      interimCalculation
      monthsRemainingCutoff
      officerCompAddback
      federalTaxes
      otherTaxes
      livingExpense
      livingPercent
      finalDecision
      manualMin
      manualMax
      prime
      spread(loanId: $loanId, bestPrice: false)
      rateHash
      tierRates
      productType
      lenderKey
    }
  }
`
